import { BlockDocument } from '../Blocks/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { PanelDocument, panelsPullQueryBuilder } from './queryBuilder';

export function panelsFamilyMember(
  configBuilder: ConfigBuilder,
  blocks: FamilyMember<BlockDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<PanelDocument> {
  const syncConfig = configBuilder<PanelDocument>(RxdbCollectionNameV2.PANELS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, panelsPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.PANELS, replicationState, [blocks, sites]);
}
